angular
	.module 'App.Value'
	.value 'searchItems', {items: []}
